import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export function AdminSettings() {
  const [json, setJson] = useState("{}");
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api.adminSettings().then((s) => {
      setJson(JSON.stringify((s as { site?: unknown }).site ?? s.site ?? s, null, 2));
    }).catch(async () => {
      const site = await api.site();
      setJson(JSON.stringify(site, null, 2));
    });
  }, []);

  async function save(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setMsg(null);
    try {
      const body = JSON.parse(json);
      await api.saveSiteSettings(body);
      setMsg("Settings saved");
    } catch (e) {
      setErr((e as Error).message);
    }
  }

  return (
    <div className="admin-page">
      <h1>Site settings</h1>
      <p className="admin-page__sub">Hero text, about blurb, and social links.</p>
      {msg && <div className="admin-msg admin-msg--ok">{msg}</div>}
      {err && <div className="admin-msg admin-msg--err">{err}</div>}
      <form className="admin-form admin-form--wide" onSubmit={save}>
        <div className="field">
          <label>Site JSON</label>
          <textarea
            rows={20}
            style={{ fontFamily: "ui-monospace, monospace", fontSize: 13 }}
            value={json}
            onChange={(e) => setJson(e.target.value)}
          />
        </div>
        <button type="submit" className="btn btn--primary">
          Save
        </button>
      </form>
    </div>
  );
}
